export const data = [
  {
    state: "Jaipur",
    value: 2556417,
    otif: 42.8571428571429,
    quantity: 63
  },
  {
    state: "Chennai",
    value: 2103358,
    otif: 44.2307692307692,
    quantity: 52
  },
  {
    state: "Hyderabad",
    value: 2681603,
    otif: 48.4848484848485,
    quantity: 66
  },
  {
    state: "Ghaziabad",
    value: 4248473,
    otif: 59.0476190476191,
    quantity: 105
  },
  {
    state: "Pune",
    value: 1259142,
    otif: 64.5161290322581,
    quantity: 31
  }
];
export const displayedColumns1 = ["areas", "otif", "value", "quantity"];
